<script lang="ts">
	import { EditionsTermsPage } from '#lib/websites/editions/pages/EditionsTermsPage/index.js';
</script>

<EditionsTermsPage />
